<template>
  <v-dialog style="overflow-y: hidden" v-model="isStorage" width="420">
    <v-card style="overflow-y: hidden">
      <v-card-title class="headline">
        <span class="headline">Storage</span>
      </v-card-title>
      <v-card-text v-if="userProfile" class="pb-1">
        <v-layout>
          Aetos AI
          <v-spacer />
          {{
            Math.round((userProfile.size / 1024) * 100 + Number.EPSILON) / 100
          }}
          GB of {{ userProfile.storage_data_limited }}GB used
        </v-layout>
        <PercentLine :height="12" :legend="true" :items="sizes" :text="'name'" :value="'size'"
          :total="userProfile.storage_data_limited" />
        <v-layout>
          <v-list width="100%" style="overflow-y: auto">
            <v-list-item style="border-bottom: 1px solid lightgrey">
              <v-list-item-icon><v-icon color="lightgrey">mdi-chart-pie</v-icon></v-list-item-icon>
              <v-list-item-title> Free </v-list-item-title>
              <v-layout justify-end style="min-width: 200px">
                {{
                  (
                    this.userProfile.storage_data_limited -
                    this.userProfile.size / 1024
                  ).toFixed(2)
                }}
                GB
              </v-layout>
            </v-list-item>
            <v-list-item style="border-bottom: 1px solid lightgrey">
              <v-list-item-icon><v-icon color="red">mdi-image</v-icon></v-list-item-icon>
              <v-list-item-title> Image </v-list-item-title>
              <v-layout justify-end style="min-width: 200px">
                {{ size(this.userProfile.image_size) }}
              </v-layout>
            </v-list-item>
            <v-list-item style="border-bottom: 1px solid lightgrey">
              <v-list-item-icon><v-icon color="#ffa500">mdi-matrix</v-icon></v-list-item-icon>
              <v-list-item-title> Model </v-list-item-title>
              <v-layout justify-end style="min-width: 200px">
                {{ size(this.userProfile.model_size) }}
              </v-layout>
            </v-list-item>
            <v-list-item style="border-bottom: 1px solid lightgrey">
              <v-list-item-icon><v-icon color="#0004fa">mdi-vector-square</v-icon></v-list-item-icon>
              <v-list-item-title> Vector </v-list-item-title>
              <v-layout justify-end style="min-width: 200px">
                {{
                  size(
                    this.userProfile.vector_size
                      ? this.userProfile.vector_size
                      : 0
                  )
                }}
              </v-layout>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon><v-icon color="#00ff00">mdi-file-document-box-check-outline</v-icon></v-list-item-icon>
              <v-list-item-title> Result </v-list-item-title>
              <v-layout justify-end style="min-width: 200px">
                {{ size(this.userProfile.result_size) }}
              </v-layout>
            </v-list-item>
          </v-list>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text @click="isStorage = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import PercentLine from "./percent-line";
import sizeUtils from "@utils/sizeUtils";
export default {
  name: "storage",
  data() {
    return {
      isStorage: false,
    };
  },
  props: {
    sizes: {
      type: Array,
      required: false,
    },
  },
  components: { PercentLine },
  computed: {
    ...mapGetters("auth", ["userProfile"]),
  },
  methods: {
    openDialog() {
      this.isStorage = true;
    },
    size(size) {
      return sizeUtils.transfSize(size);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/storage.vue